module.exports = __webpack_public_path__ + "static/media/p_2.30721a4c.jpg";